(() => {
  const selector = '.product-image:has(.product-image-secondary), .pcc-image:has(.pcc-img-secondary)';
  const mobile = window.matchMedia('(max-width: 749px)');
  let activeCard = null;
  let candidateCard = null;
  let touchedCard = null;
  let candidateSince = 0;
  let monitor = null;

  const primary = (card) => card?.querySelector('.product-image-primary, .pcc-img-primary');
  const secondary = (card) => card?.querySelector('.product-image-secondary, .pcc-img-secondary');

  const showSecond = (card) => {
    const first = primary(card);
    const second = secondary(card);
    if (!first || !second) return;
    if (activeCard && activeCard !== card) showFirst(activeCard);
    activeCard = card;
    card.classList.add('is-secondary-visible');
    first.style.setProperty('opacity', '0', 'important');
    second.style.setProperty('display', 'block', 'important');
    second.style.setProperty('visibility', 'visible', 'important');
    second.style.setProperty('opacity', '1', 'important');
    second.style.setProperty('transform', 'scale3d(1.1,1.1,1.1)', 'important');
  };

  const showFirst = (card) => {
    if (!card) return;
    const first = primary(card);
    const second = secondary(card);
    card.classList.remove('is-secondary-visible');
    if (first) first.style.removeProperty('opacity');
    if (second) {
      second.style.removeProperty('display');
      second.style.removeProperty('visibility');
      second.style.removeProperty('opacity');
      second.style.removeProperty('transform');
    }
    if (activeCard === card) activeCard = null;
  };

  const getCenteredCard = () => {
    const centerX = window.innerWidth / 2;
    let best = null;
    let bestDistance = Infinity;

    document.querySelectorAll(selector).forEach((card) => {
      const rect = card.getBoundingClientRect();
      if (rect.right <= 0 || rect.left >= window.innerWidth || rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      const distance = Math.abs((rect.left + rect.right) / 2 - centerX);
      if (distance < bestDistance) {
        best = card;
        bestDistance = distance;
      }
    });
    return best;
  };

  const checkCenter = () => {
    if (!mobile.matches || document.hidden || touchedCard) return;
    const centered = getCenteredCard();

    if (centered !== candidateCard) {
      candidateCard = centered;
      candidateSince = performance.now();
      showFirst(activeCard);
      return;
    }

    if (centered && centered !== activeCard && performance.now() - candidateSince >= 500) {
      showSecond(centered);
    }
  };

  const startMonitor = () => {
    if (monitor) window.clearInterval(monitor);
    monitor = null;
    showFirst(activeCard);
    candidateCard = null;
    candidateSince = 0;
    if (mobile.matches) monitor = window.setInterval(checkCenter, 80);
  };

  document.addEventListener('touchstart', (event) => {
    if (!mobile.matches) return;
    const card = event.target.closest(selector);
    if (!card) return;
    touchedCard = card;
    candidateCard = null;
    showSecond(card);
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!mobile.matches) return;
    const touch = event.touches[0];
    if (!touch) return;
    const card = document.elementFromPoint(touch.clientX, touch.clientY)?.closest(selector) || null;
    if (card === touchedCard) return;
    showFirst(activeCard);
    touchedCard = card;
    if (card) showSecond(card);
  }, { capture: true, passive: true });

  const finishTouch = () => {
    showFirst(activeCard);
    touchedCard = null;
    candidateCard = null;
    candidateSince = performance.now();
  };

  document.addEventListener('touchend', finishTouch, { capture: true, passive: true });
  document.addEventListener('touchcancel', finishTouch, { capture: true, passive: true });
  mobile.addEventListener?.('change', startMonitor);
  document.addEventListener('shopify:section:load', startMonitor);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) showFirst(activeCard);
  });
  startMonitor();
})();